import {PreferencesSurveySource} from "@pg-rp/common-types";

import {IApplicationData} from "../../../application/types/IApplicationData";
import {IClientPayload} from "../../../for_you/api/for_you_client";
import {OfferType} from "../../../offer/types/OfferType";
import {PREFERENCES_FORM_MAX_DEFAULT} from "../../constants/preferences/application_preferences_form";
import {ISurveyData} from "../../types/IBuildSurveyParams";
import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";
import {IUserProfile} from "../../types/IUserProfile";

export interface IHomeMatchBasicContactData {
    email: string;
    name?: string;
    phone?: string;
    marketingConsent?: boolean;
}

interface IBuildHomeMatchBasicClientPayloadParams {
    values: IPreferencesDefaultValues;
    contactData: IHomeMatchBasicContactData;
    maxBudget?: number;
    surveySource: PreferencesSurveySource;
    isExplicitSubmit: boolean;
}

export const hasCompletedHomeMatchSurvey = (clientInfo: ISurveyData | null | undefined): boolean => {
    if (!clientInfo) {
        return false;
    }

    return Boolean(
        clientInfo.last_survey_date ||
            clientInfo.regions?.length ||
            clientInfo.rooms?.lower ||
            clientInfo.rooms?.upper ||
            clientInfo.price?.upper ||
            clientInfo.price?.lower
    );
};

export const getHomeMatchBasicContactData = (
    userProfile: IUserProfile | null | undefined,
    application: IApplicationData | null | undefined
): IHomeMatchBasicContactData | null => {
    const email = userProfile?.email || application?.email;

    if (!email) {
        return null;
    }

    return {
        email,
        name: userProfile?.name || application?.name || undefined,
        phone: userProfile?.phone || application?.phone || undefined,
        marketingConsent: userProfile?.email_marketing_consent ?? application?.marketing_email ?? false
    };
};

export const buildHomeMatchBasicClientPayload = (params: IBuildHomeMatchBasicClientPayloadParams): IClientPayload => {
    const {values, contactData, surveySource, isExplicitSubmit, maxBudget = PREFERENCES_FORM_MAX_DEFAULT} = params;
    const regions = values.regionSelector.map((region) => region.value);

    const lower = typeof values.rooms.lower === "number" ? values.rooms.lower : 1;
    const upper = typeof values.rooms.upper === "number" ? values.rooms.upper : 5;
    const rooms = {lower, upper};
    const price = values.budget && values.budget !== maxBudget ? {lower: 0, upper: values.budget} : {lower: 0, upper: maxBudget};

    return {
        email: contactData.email,
        name: contactData.name,
        phone: contactData.phone || "",
        marketing_consent: contactData.marketingConsent,
        financing_services: values.creditPlan,
        regions,
        rooms,
        types: [OfferType.FLAT, OfferType.HOUSE],
        price,
        area: {lower: 0, upper: 0},
        loan_installment: {lower: 0, upper: 0},
        distance: 0,
        survey_source: surveySource,
        system_comments: isExplicitSubmit ? "Ankieta świadomie zapisana przez użytkownika" : "Ankieta wysłana poprzez zamknięcie modala",
        explicit_submit: isExplicitSubmit,
        no_hm_enable: true
    };
};
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {IApplicationData} from "../../../application/types/IApplicationData";
import {IClientPayload} from "../../../for_you/api/for_you_client";
import {OfferType} from "../../../offer/types/OfferType";
import {PREFERENCES_FORM_MAX_DEFAULT} from "../../constants/preferences/application_preferences_form";
import {ISurveyData} from "../../types/IBuildSurveyParams";
import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";
import {IUserProfile} from "../../types/IUserProfile";

export interface IHomeMatchBasicContactData {
    email: string;
    name?: string;
    phone?: string;
    marketingConsent?: boolean;
}

interface IBuildHomeMatchBasicClientPayloadParams {
    values: IPreferencesDefaultValues;
    contactData: IHomeMatchBasicContactData;
    maxBudget?: number;
    surveySource: PreferencesSurveySource;
    isExplicitSubmit: boolean;
}

export const hasCompletedHomeMatchSurvey = (clientInfo: ISurveyData | null | undefined): boolean => {
    if (!clientInfo) {
        return false;
    }

    return Boolean(
        clientInfo.last_survey_date ||
            clientInfo.regions?.length ||
            clientInfo.rooms?.lower ||
            clientInfo.rooms?.upper ||
            clientInfo.price?.upper ||
            clientInfo.price?.lower
    );
};

export const getHomeMatchBasicContactData = (
    userProfile: IUserProfile | null | undefined,
    application: IApplicationData | null | undefined
): IHomeMatchBasicContactData | null => {
    const email = userProfile?.email || application?.email;

    if (!email) {
        return null;
    }

    return {
        email,
        name: userProfile?.name || application?.name || undefined,
        phone: userProfile?.phone || application?.phone || undefined,
        marketingConsent: userProfile?.email_marketing_consent ?? application?.marketing_email ?? false
    };
};

export const buildHomeMatchBasicClientPayload = (params: IBuildHomeMatchBasicClientPayloadParams): IClientPayload => {
    const {values, contactData, surveySource, isExplicitSubmit, maxBudget = PREFERENCES_FORM_MAX_DEFAULT} = params;
    const regions = values.regionSelector.map((region) => region.value);

    const lower = typeof values.rooms.lower === "number" ? values.rooms.lower : 1;
    const upper = typeof values.rooms.upper === "number" ? values.rooms.upper : 5;
    const rooms = {lower, upper};
    const price = values.budget && values.budget !== maxBudget ? {lower: 0, upper: values.budget} : {lower: 0, upper: maxBudget};

    return {
        email: contactData.email,
        name: contactData.name,
        phone: contactData.phone || "",
        marketing_consent: contactData.marketingConsent,
        financing_services: values.creditPlan,
        regions,
        rooms,
        types: [OfferType.FLAT, OfferType.HOUSE],
        price,
        area: {lower: 0, upper: 0},
        loan_installment: {lower: 0, upper: 0},
        distance: 0,
        survey_source: surveySource,
        system_comments: isExplicitSubmit ? "Ankieta świadomie zapisana przez użytkownika" : "Ankieta wysłana poprzez zamknięcie modala",
        explicit_submit: isExplicitSubmit,
        no_hm_enable: true
    };
};
